const NotFound = () => {
  return (
    <div className='flex w-full max-w-[var(--thread-max-width)] flex-grow flex-col h-full bg-card dark:bg-card-dark text-card-foreground dark:text-card-foreground-dark theme-transition'>
      <div className='flex w-full flex-grow flex-col items-center justify-center'>
        <img
          src='/assets/notfound.png'
          alt='404 Not Found'
          className='w-64 h-64 mx-auto mb-8'
        />
      </div>
    </div>
  );
};

export default NotFound;
